import axios from 'axios';

const api = axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URL ?? '/api',
    timeout: 120000, // 120 seconds timeout
    headers: {
        'Content-Type': 'application/json',
    }
});

export const getChannels = () => api.get('/Yt/channels');
export const getVideos = () => api.get('/Yt/videos');
export const getTrendingVideos = () => api.get('/Yt/trending');
export const getShorts = () => api.get('/Yt/shorts');
export const getDailyPeaks = () => api.get('/Yt/dailypeaks');

//import axios from 'axios';

//const api = axios.create({
//    baseURL: 'http://localhost:5008/api'
//});

//export const getChannels = () => api.get('/Yt/channels');
//export const getVideos = () => api.get('/Yt/videos');
//export const getTrendingVideos = () => api.get('/Yt/trending');
//export const getMostViewedTodayVideos = () => api.get('/Yt/mostviewedtoday');
//export const admin = async (password: string) => {
//    return axios.post('http://localhost:5008/api/Yt/admin', { password });
//};